<div class="no-data">
  <mat-spinner [color]="color"></mat-spinner>
</div>
